import { getTransitionFlags } from "../transition.js";
import { defaults } from "@videojs/utils/object";
//#region src/core/ui/menu/core.ts
/** Combines direct and nested option-menu state for a parent trigger. */
function resolveMenuOptionState(states) {
	const options = [...states];
	if (options.length === 0) return null;
	const visible = options.filter((state) => !state.hidden);
	const availability = visible.filter((state) => state.availability === "available").length > 0 ? "available" : options.every((state) => state.availability === "unsupported") ? "unsupported" : "unavailable";
	return {
		value: options.length === 1 ? options[0].value : "",
		disabled: visible.length === 0 || visible.every((state) => state.disabled),
		hidden: visible.length === 0,
		availability
	};
}
/** Base menu logic: ARIA attributes and open/close state computation. */
var MenuCore = class MenuCore {
	static defaultProps = {
		side: "bottom",
		align: "start",
		open: false,
		defaultOpen: false,
		closeOnEscape: true,
		closeOnOutsideClick: true
	};
	#props = { ...MenuCore.defaultProps };
	#input = null;
	get props() {
		return this.#props;
	}
	constructor(props) {
		if (props) this.setProps(props);
	}
	setProps(props) {
		this.#props = defaults(props, MenuCore.defaultProps);
	}
	setInput(input) {
		this.#input = input;
	}
	getState() {
		const input = this.#input;
		const isSubmenu = input.isSubmenu;
		return {
			open: input.active,
			status: input.status,
			side: isSubmenu ? void 0 : this.#props.side,
			align: isSubmenu ? void 0 : this.#props.align,
			isSubmenu,
			...getTransitionFlags(input.status)
		};
	}
	getTriggerAttrs(state, contentId) {
		return {
			...!state.isSubmenu && { tabIndex: 0 },
			"aria-haspopup": "menu",
			"aria-expanded": state.open && state.status !== "ending" ? "true" : "false",
			"aria-controls": contentId
		};
	}
	getContentAttrs() {
		return {
			role: "menu",
			tabIndex: -1
		};
	}
	getPopupAttrs() {
		return { popover: "manual" };
	}
};
//#endregion
export { MenuCore, resolveMenuOptionState };

//# sourceMappingURL=core.js.map